import { Slide } from "@jelly/lesson";

const principle: Slide = {
  titleHtml: `<div style="text-align:center">Vehicle Sound Simulation</div>`,
  title: "Introduction",
  layout: {
    type: "customCase040201",
    options: {},
  },
};

export default principle;
